import type { WorkingTreeChangeFileRow } from '../types.js';

export function rowRank(row: WorkingTreeChangeFileRow): number {
  if (row.change === 'moved') return 3;
  if (row.change === 'modified') return 2;
  if (row.change === 'added') return 1;
  return 0;
}

export function pickPreferredChangedFileRow(
  a: WorkingTreeChangeFileRow,
  b: WorkingTreeChangeFileRow,
): WorkingTreeChangeFileRow {
  if (rowRank(a) !== rowRank(b)) return rowRank(a) > rowRank(b) ? a : b;
  const aHasPatch = Boolean(a.patchContent?.trim());
  const bHasPatch = Boolean(b.patchContent?.trim());
  if (aHasPatch !== bHasPatch) return aHasPatch ? a : b;
  const aHasMoveMeta = Boolean(a.movedFromPathInRepo || a.movedFromWorkspaceRelPath);
  const bHasMoveMeta = Boolean(b.movedFromPathInRepo || b.movedFromWorkspaceRelPath);
  if (aHasMoveMeta !== bHasMoveMeta) return aHasMoveMeta ? a : b;
  return a;
}
